import { parse, stringify } from '../../util/urlHelpers';
import { loadData as SearchPageLoader } from '../SearchPage/SearchPage.duck';

export const loadData = (params, search, config) => (dispatch, getState) => {
  const parsed = parse(search, {
    latlng: ['origin'],
    latlngBounds: ['bounds'],
  });

  // Add initial default values for sell as is tabs

  const requiredParams = ['asIs', 'sellAsIsState', 'tab'];

  const hasSearchParams = Object.keys(parsed).length > 0;

  const isMissingRequiredParams = !hasSearchParams || requiredParams.some(key => !(key in parsed));

  const updatedSearch = isMissingRequiredParams
    ? stringify({
        ...parsed,
        asIs: parsed.asIs ?? true,
        meta_status: parsed?.meta_status ?? 'sellAsIs',
        owned: parsed.owned ?? false,
        sellAsIsState: parsed.sellAsIsState ?? 'buying',
        tab: parsed.tab ?? 'forSale',
      })
    : stringify(parsed);

  return dispatch(SearchPageLoader(params, updatedSearch, config)(dispatch, getState));
};
